var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGravityHammer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.2971 21.7063L15.6216 11.2723C15.6216 11.2723 19.6521 10.0633 21.8886 11.0668C24.1251 12.0703 27.0486 13.9498 27.0486 13.9498L22.4661 17.3593L22.4931 18.3943L28.3311 14.8333C28.3311 14.8333 33.3651 14.4178 35.9916 16.0348C38.6181 17.6518 43.5396 21.2128 47.3646 20.5753C51.1896 19.9378 53.4621 19.2913 54.5106 18.6928C55.5591 18.0943 56.6946 17.3593 56.6946 17.3593C56.6946 17.3593 57.4506 18.0148 57.1986 18.8098C56.9481 19.6048 54.5991 21.4903 54.1521 22.4113C53.7051 23.3323 53.6016 24.2188 53.6016 24.2188L50.8551 24.2308L51.7251 27.3103L53.6016 26.9788L55.3686 27.0568L55.4796 27.7513C55.4796 27.7513 57.2946 25.1578 57.9081 25.4323C58.5231 25.7068 59.1231 26.7568 59.1231 26.7568L61.3866 26.9863H64.0536L65.8446 27.0568C65.8446 27.0568 66.9981 27.0013 67.2291 26.9863C67.4601 26.9713 68.9496 27.3643 68.9496 27.3643L70.2336 27.0553L71.1035 27.3643L72.8705 26.6473L73.592 26.6743L74.858 26.5378L76.9565 27.0343L78.308 26.9878L79.8186 27.5593H80.4756L81.2615 27.9733L96.665 28.0288L98.1005 27.6973L99.083 28.0723L100.696 27.2563L102.566 27.1093C102.566 27.1093 104.215 26.3068 105.002 26.5393C105.79 26.7718 106.589 27.0193 106.589 27.0193L108.038 26.4433L109.757 26.3983L111.508 25.8403L112.234 24.9718L113.117 24.9928L114.001 25.7098C114.001 25.7098 116.804 25.7488 117.41 26.5483C118.016 27.3478 118.601 28.5748 118.447 29.4403C118.292 30.3058 117.884 31.3738 117.253 31.7698C116.621 32.1658 114.608 32.7223 114.608 32.7223L114.664 33.4393H113.393L112.234 32.9398L110.564 32.7118L109.537 32.2168L107.929 32.1163L105.776 31.5088L104.2 32.0188L102.575 31.7713L100.312 31.3993L99.0966 30.6268L97.4225 30.9343L94.0716 31.0843L88.8815 31.0213L85.901 30.9073L83.5701 30.9358L81.6501 31.6783H80.3795L79.7721 31.1263L78.6126 31.7338L77.3631 31.6078L76.4181 31.6633L75.0306 32.2198L73.3986 31.8973L71.8205 31.6273L68.4531 31.5733L66.2375 31.7728L63.3186 31.8973L60.0081 31.9918L58.9566 32.7253L57.6561 34.6228L56.6931 34.2988L55.6446 33.2218L54.8166 33.3868L54.2646 34.0498L53.4501 33.5533L52.3701 34.0528C52.3701 34.0528 51.4071 33.4753 50.5986 33.8263C49.7916 34.1773 46.9401 36.2173 46.9401 36.2173L46.3146 37.2538L46.9221 38.8948L46.7016 40.2343L42.4506 42.2218L41.7276 43.1323C41.7276 43.1323 41.6481 43.4893 40.1991 43.6528C38.7501 43.8163 37.5756 43.5508 37.5756 43.5508C37.5756 43.5508 36.6126 42.6193 36.2661 42.6643C35.9196 42.7093 35.1066 43.5478 35.1066 43.5478L33.4851 44.0443H32.2911L30.7566 45.3853C30.7566 45.3853 30.6516 45.6208 29.3511 45.8188C28.0506 46.0168 27.1461 46.1053 26.7651 46.0123C26.3841 45.9193 24.8541 44.9728 24.6726 44.9818C24.4911 44.9908 23.4021 45.1468 23.4021 45.1468L21.8856 46.3093L20.8071 46.3123C20.8071 46.3123 20.3391 47.0968 19.9236 47.2993C19.5081 47.5018 17.4396 48.1588 16.5561 48.1423C15.6726 48.1258 14.2371 47.4643 14.2371 47.4643L12.8016 47.4178C12.8016 47.4178 11.7711 47.1823 11.2806 46.7053C10.7901 46.2283 10.4271 46.0843 10.4271 46.0843C10.4271 46.0843 9.90205 46.3048 8.92255 46.3873C7.94305 46.4698 6.48805 46.7053 6.48805 46.7053C6.48805 46.7053 5.58055 46.4638 5.20405 45.7408C4.82755 45.0178 4.18855 43.6003 4.18855 43.6003C4.18855 43.6003 3.97255 42.0553 3.93805 41.9383C3.90355 41.8213 2.64355 37.6378 2.64355 37.6378L3.10855 35.8738L2.67355 34.7668L3.19555 30.8473C3.19555 30.8473 3.08305 29.4643 4.57555 29.2498C6.06805 29.0353 9.32305 28.3348 9.32305 28.3348L10.2336 27.4243L12.3861 26.8453C12.3861 26.8453 13.1136 26.3803 12.4851 25.3663C11.8566 24.3523 10.4151 22.4848 10.2741 22.2283C10.1331 21.9703 9.00355 19.7548 9.90205 19.7233C10.8006 19.6918 12.3861 20.4688 12.3861 20.4688L14.2911 21.7108L14.2971 21.7063Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.915 20.2152L50.8585 24.2307",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5664 20.4313L51.2934 31.2448H52.6389L51.4839 27.1528",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2271 20.4312L43.8186 30.2772L45.0486 30.2907L46.3176 20.6082",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3179 22.4098C46.3179 22.4098 47.5044 30.8053 48.2094 31.2448H46.5939C46.5939 31.2448 45.3519 27.9733 45.4389 27.3103",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5664 31.2448C48.5664 31.2448 48.7899 25.5538 49.3284 24.2308",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2093 21.0358C48.2093 21.0358 47.3813 26.8033 47.2988 27.3103",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0087 26.6742L49.3262 31.2447H51.2927",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6384 31.2447C52.6384 31.2447 53.0524 28.5657 54.7084 27.3102",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9006 28.6317C51.9006 28.6317 52.4016 27.5247 52.8456 27.3102",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.666 27.3102L61.9555 31.7682",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5972 26.9232C63.4862 27.1302 64.5212 31.7682 64.5212 31.7682",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8477 27.3102C65.9722 27.6282 66.6337 31.2447 66.6337 31.2447",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8772 27.3102C67.8772 27.3102 68.3737 28.9512 68.4562 29.9877C68.5387 31.0227 68.4562 31.5687 68.4562 31.5687",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2363 27.3102C70.2363 27.3102 70.8573 28.7187 70.9398 29.5392C71.0223 30.3597 70.9398 31.2447 70.9398 31.2447",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8867 26.9232C72.8867 26.9232 73.2587 28.0137 73.3007 29.5392C73.3427 31.0647 73.0937 31.5687 73.0937 31.5687",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6973 26.9232V34.2942",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3302 26.9232C75.3302 26.9232 75.7862 28.2282 75.6197 29.4387C75.4547 30.6492 75.0332 32.2137 75.0332 32.2137",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5654 27.3102C77.5654 27.3102 77.6899 28.2072 77.5654 29.3457C77.4409 30.4842 77.1094 31.2447 77.1094 31.2447",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0439 28.3317C81.0439 28.3317 81.3334 29.3982 82.1209 29.5692C82.9084 29.7402 95.0809 29.5692 95.0809 29.5692C95.0809 29.5692 96.6964 29.7282 97.3579 28.9887C98.0209 28.2492 97.8965 27.9177 97.8965 27.9177",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0862 28.0707C99.0862 28.0707 99.6967 28.7037 99.0862 30.4017",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M101.044 27.5863C101.044 27.5863 101.665 27.9868 101.665 29.1118C101.665 30.2368 100.795 31.2463 100.795 31.2463",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M103.61 27.3102C103.61 27.3102 104.291 27.5862 104.189 29.3457C104.102 30.8697 103.112 31.5687 103.112 31.5687",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M110.567 25.9166C110.567 25.9166 111.911 26.6231 111.851 29.1116C111.796 31.3811 110.567 32.2136 110.567 32.2136",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M109.532 26.9232C109.532 26.9232 110.174 27.3582 110.195 29.1117C110.217 30.9822 109.325 31.8927 109.325 31.8927",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M106.343 27.3102C106.343 27.3102 106.839 27.9177 106.839 29.1117C106.839 29.9877 106.343 31.2462 106.343 31.2462",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M118.143 29.7942C118.143 29.7942 116.984 28.8867 115.797 29.6442C115.797 29.6442 114.582 28.7907 113.34 29.5677C113.34 29.5677 113.091 30.4872 112.623 31.2447C112.154 32.0022 111.51 32.9157 111.51 32.9157",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M115.797 29.6442C115.797 29.6442 115.607 30.8937 114.638 32.2137",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M111.989 26.2618C111.989 26.2618 112.486 27.0343 113.342 27.3103C114.197 27.5863 117.869 27.4483 117.869 27.4483",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7102 27.5592L54.9037 33.1617",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3301 29.5392V33.1617",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9051 25.2402V25.8387C36.9051 25.8387 37.3191 26.0682 37.4571 26.5377C37.5951 27.0072 37.7331 28.1937 37.7331 28.1937C37.7331 28.1937 38.1741 29.1462 38.2296 29.5392C38.2851 29.9322 37.8156 30.3597 37.8156 30.3597C37.8156 30.3597 35.8281 30.5937 35.5251 30.3597C35.2221 30.1257 34.5306 28.4922 34.3926 27.6387C34.2546 26.7852 34.3926 26.2602 34.3926 26.2602C34.3926 26.2602 34.2816 24.2982 35.5521 24.2307C36.8226 24.1632 36.9051 24.6402 36.9051 25.2402V25.2402Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3926 26.2617C34.3926 26.2617 35.0556 25.3332 36.9051 25.8387",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3506 27.3102C34.3506 27.3102 35.6571 26.7447 37.5786 27.1107",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8574 28.7457C34.8574 28.7457 36.2974 28.3587 37.8169 28.7457",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5586 24.2306C34.5586 24.2306 32.9851 22.6361 31.9081 24.1721C31.3336 24.9926 31.0576 26.5691 31.0771 27.9701C31.0936 29.1926 31.3351 30.2801 31.7986 30.6086",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0781 27.9703C31.0781 27.9703 32.4491 27.0883 34.3331 28.2763",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5217 25.3617C31.5217 25.3617 33.3037 24.7212 34.3312 25.9752",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0988 25.7098V26.8288C41.0988 26.8288 41.0868 28.0978 39.6798 27.9673C38.2713 27.8353 37.6758 27.7393 37.6758 27.7393",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M21.459 24.8531L20.922 24.9701L20.838 25.5866L20.01 26.2616H19.41L18.582 27.7376",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4316 23.8392L20.9226 24.9702",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3502 19.2627C22.3502 19.2627 21.5012 19.0002 20.7977 19.1112C20.0942 19.2222 19.2662 19.9467 19.2662 19.9467L20.6612 21.4167L19.5542 20.2512H18.5822L18.1472 20.7342V21.4167L19.4312 22.6377L20.3147 22.7622L19.4312 23.5047V23.8392H18.9752L18.1052 24.6252L17.9402 25.1982L16.4492 26.8272L17.9402 25.1982L19.4102 26.2617",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1475 21.4167C18.1475 21.4167 17.816 21.4587 17.465 21.7062C17.1125 21.9552 16.409 23.1762 16.886 23.9832C17.3615 24.7902 18.107 24.6252 18.107 24.6252",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5605 22.6722L17.03 18.2562H18.1475L18.5825 20.0232",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0676 20.2152C11.0676 20.2152 11.8956 22.2027 12.3921 22.6722C12.8886 23.1417 13.6476 24.2307 13.6476 24.2307L14.5461 26.2962",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M14.408 27.3102L19.4015 29.9877C19.4015 29.9877 20.1785 30.7062 20.9225 30.7062C21.6665 30.7062 22.469 30.4572 22.469 30.4572",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2522 32.6052L10.2397 32.2782L14.9752 35.8692",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4814 32.1132L14.6554 31.5687",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5811 32.9727L15.7551 32.4282",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8691 33.8218L17.0446 33.2758",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M5.96021 35.3982C6.04271 35.5092 7.97471 41.3337 7.97471 41.3337C7.97471 41.3337 8.61071 43.0182 9.90821 43.1277",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92703 42.6972L7.69853 42.9447C7.69853 42.9447 7.41203 43.1817 7.44503 43.5687C7.47803 43.9557 8.38853 46.3842 8.38853 46.3842",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58008 35.6742L6.67858 41.9337C6.67858 41.9337 6.78958 42.3477 6.37558 42.9447C5.96158 43.5417 5.79658 43.7337 5.96158 44.1762C6.12658 44.6187 6.98758 46.8312 6.98758 46.8312",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1477 37.2477L18.8797 39.9087C18.8797 39.9087 19.2667 40.8492 19.7347 40.9392L20.0212 42.0507L20.6602 42.8232C20.6602 42.8232 21.1147 44.5212 21.2257 44.6112C21.3367 44.7012 23.0632 44.1957 23.0632 44.1957",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4005 40.9393L18.148 41.1358L17.8525 41.6098L18.769 44.3413L20.9575 43.8703",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M16.724 37.2477L17.345 39.6222C17.345 39.6222 17.5535 40.5612 16.448 40.8372",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M30.942 35.3983L31.521 37.6618C31.521 37.6618 30.996 38.4598 30.942 38.8888C30.888 39.3178 31.4115 39.5338 31.383 39.9088C31.3545 40.2838 31.0755 40.9393 31.0755 40.9393L31.686 42.6403L29.832 43.1263",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1025 35.2047L32.7055 37.2477C32.7055 37.2477 32.974 38.3322 34.306 38.2467",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2675 38.2527L32.213 38.4597C32.213 38.4597 31.772 38.6517 32.102 39.9102C32.4335 41.1687 32.6225 41.6937 32.6225 41.6937L35 41.2542",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0352 47.0202L18.8507 46.3842",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0234 45.0327L30.0864 44.3412",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1137 27.3793C52.6957 27.3493 53.6047 26.9788 53.6047 26.9788L55.1512 27.1438L55.4827 27.7513L56.7532 26.0398C56.7532 26.0398 57.0847 25.4323 57.9127 25.4323C58.7407 25.4323 59.1277 26.7568 59.1277 26.7568L60.5347 27.0883C60.5347 27.0883 61.0612 26.8123 61.6672 26.9773C62.2747 27.1423 62.9377 26.7568 63.5992 26.9218C64.2622 27.0868 64.7032 27.1978 65.0347 27.1978C65.3662 27.1978 65.7517 27.0868 66.1942 27.1423C66.6352 27.1978 66.9667 26.9218 67.6852 26.9773C68.4037 27.0328 68.7337 27.3643 68.9557 27.3643C69.1777 27.3643 69.5077 27.1438 70.0597 27.1993C70.6117 27.2548 70.6117 27.3643 71.1082 27.3643C71.6047 27.3643 72.4882 26.8678 72.8752 26.6473C73.2622 26.4268 74.0347 26.8678 74.0347 26.8678C74.0347 26.8678 74.1997 26.3713 74.8627 26.5363C75.5257 26.7013 76.0777 26.9773 76.9612 27.0328C77.8447 27.0883 78.1207 26.9218 78.1207 26.9218C78.1207 26.9218 79.8322 27.4738 79.9432 27.6388C80.0542 27.8038 80.7157 27.3073 80.9917 27.6388L81.2677 27.9703L96.6712 28.0258C96.6712 28.0258 97.6657 27.6388 98.1067 27.6943C98.5477 27.7498 99.2107 28.1353 99.2107 28.1353L100.702 27.2518L102.8 27.0868C102.8 27.0868 104.347 26.4793 105.284 26.6458C106.222 26.8123 106.333 27.0868 106.333 27.0868C106.333 27.0868 106.996 26.8663 107.327 26.9758C107.327 26.9758 108.874 26.0368 109.591 26.5888C109.591 26.5888 110.198 25.6498 111.854 25.7608V25.2268L113.125 24.9883L114.008 25.7053C114.008 25.7053 118.009 24.9883 118.424 28.7413C118.84 32.4958 114.614 32.7163 114.614 32.7163L114.67 33.4333C114.67 33.4333 113.675 33.6538 113.069 33.4333L112.682 32.8813C112.682 32.8813 110.971 33.2683 109.315 32.0533C109.315 32.0533 108.598 32.3293 107.935 32.1088C107.272 31.8883 106.334 31.2808 105.782 31.5013C105.782 31.5013 105.341 31.8883 104.458 31.9978C103.574 32.1088 102.635 31.5568 102.635 31.5568L100.316 31.3918L99.1012 30.6193C99.1012 30.6193 98.3287 30.6748 97.8307 30.8398C97.3327 31.0048 95.7877 31.0603 94.5727 31.1713C93.3577 31.2823 90.8182 31.1158 90.8182 31.1158C90.8182 31.1158 84.4147 30.7288 83.4202 30.9508C82.4257 31.1713 81.6532 31.6678 81.6532 31.6678H80.3827L79.7752 31.1158C79.7752 31.1158 79.2787 31.5568 78.6157 31.7233C77.9527 31.8883 77.2912 31.4473 76.7392 31.5583C76.1872 31.6693 75.0832 32.3308 74.8072 32.2213C74.5312 32.1103 73.7587 31.7248 73.7587 31.7248L72.9307 32.1118C72.9307 32.1118 73.3717 31.5598 72.1582 31.6153C70.9447 31.6708 69.9502 31.3948 69.3982 31.6153C68.8462 31.8358 68.2387 31.6708 68.2387 31.6708C68.2387 31.6708 67.1902 31.5058 66.6922 31.6708C66.1957 31.8358 65.4772 31.9468 65.4772 31.9468L64.3177 31.8913L62.1652 31.9468L59.1292 32.0023L58.9642 32.7193C58.9642 32.7193 57.9157 34.4308 57.4732 34.8178C57.0322 35.2048 56.7007 34.5418 56.7007 34.5418L55.6522 33.2173L54.8242 33.3823C54.8242 33.3823 54.4927 33.9898 54.2722 34.0453C54.0517 34.1008 53.3332 33.4378 53.3332 33.4378C53.3332 33.4378 52.6702 34.1008 52.0627 34.1008C51.4552 34.1008 50.3512 33.4603 48.5287 34.9393C46.7062 36.4198 46.3207 36.6958 46.3207 36.6958L46.9282 38.6278L46.7077 40.2283L43.5607 41.6638L42.4567 42.2158L42.1807 42.9328C42.1807 42.9328 40.6342 43.6498 39.5857 43.7608C38.5372 43.8718 37.8187 43.7608 37.8187 43.7608C37.8187 43.7608 36.6592 42.6568 36.2722 42.6568C35.8852 42.6568 35.3887 42.8773 35.3887 42.8773L35.1127 43.5403L33.7327 44.0368H33.0157C33.0157 44.0368 32.5747 43.8163 32.2987 44.0368C32.0227 44.2573 31.2502 45.1963 31.2502 45.1963C31.2502 45.1963 29.8702 45.7483 28.8757 45.9133C27.8812 46.0783 26.7232 46.0783 26.3917 45.9133C26.0602 45.7483 25.0672 44.9743 24.6802 44.9743C24.2932 44.9743 23.4097 45.1393 23.4097 45.1393C23.4097 45.1393 22.9132 45.5803 22.6927 45.8023C22.4722 46.0228 22.1407 46.3543 21.7537 46.2988C21.3667 46.2433 20.8147 46.3048 20.8147 46.3048C20.8147 46.3048 20.5387 46.8508 19.9312 47.2918C19.3237 47.7328 16.5082 48.2308 15.6802 48.1198C14.8522 48.0088 14.6317 47.6788 14.2447 47.4568C13.8577 47.2348 13.5817 47.2918 13.2502 47.4013C12.9187 47.5123 11.1517 47.1808 10.9867 46.7938C10.8217 46.4068 10.9312 46.0768 10.4347 46.0768C9.93816 46.0768 9.82716 46.4083 9.33066 46.5178C8.83416 46.6273 7.28766 46.7938 7.28766 46.7938C7.28766 46.7938 6.01716 47.0698 5.41116 46.0768C4.80516 45.0838 4.19616 43.5928 4.19616 43.5928V42.7648L2.64966 37.6303C2.64966 37.6303 2.92566 36.8578 3.09066 36.1948C3.25566 35.5318 2.64966 34.9798 2.64966 34.9798L3.20166 30.8398C3.20166 30.8398 3.38316 29.6068 4.19616 29.4328L9.33066 28.3288L10.2412 27.4183L12.3937 26.8393C12.3937 26.8393 12.7252 25.6798 12.3937 25.1008C12.0622 24.5218 10.7377 22.9483 10.7377 22.9483C10.7377 22.9483 8.91516 20.3818 9.90966 19.7188C10.9042 19.0558 14.2987 21.7063 14.2987 21.7063L15.6232 11.2723C15.6232 11.2723 18.7702 9.69883 22.4137 11.2723C26.0572 12.8458 27.0517 13.9498 27.0517 13.9498L22.9117 17.3173C22.9117 17.3173 21.8767 18.1453 22.4977 18.3943C23.1187 18.6433 23.9467 17.8978 23.9467 17.8978L28.3357 14.8333C28.3357 14.8333 33.2632 14.4613 35.9962 16.0348C38.7292 17.6083 43.1182 21.0178 47.3692 20.5753C51.6202 20.1343 54.1042 19.2508 56.8657 17.2078C56.8657 17.2078 57.7492 17.9248 56.8657 19.8028C55.9822 21.6793 53.6077 21.5143 53.6077 24.2188L51.2962 24.2293",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1097 24.2622L41.4592 24.2742C41.4592 24.2742 41.0182 24.3852 41.0722 25.1022C41.1277 25.8192 42.3967 25.7097 42.3967 25.7097H43.8172",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3918 26.8408C12.3918 26.8408 14.1303 26.2063 15.1248 26.5378C16.1193 26.8693 20.7558 28.9738 21.3633 29.3563C21.9708 29.7388 22.4673 30.4573 22.4673 30.4573L37.4283 30.7333C37.4283 30.7333 39.9678 30.4573 40.3548 30.2368L45.0468 30.2923C45.0468 30.2923 45.8748 30.2923 45.7638 31.2313C45.6528 32.1703 46.3158 36.6973 46.3158 36.6973",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1244 26.5378C15.1244 26.5378 13.0814 27.1453 13.7999 28.5253C14.5169 29.9053 20.3144 34.0468 20.3144 34.0468L32.0744 32.3353L35.0564 33.6598C35.0564 33.6598 40.3559 31.6723 41.9579 34.7083C43.5584 37.7443 43.4489 39.7873 43.4489 39.7873L45.1604 39.1243L46.9274 38.6278",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64771 34.9842L4.30371 34.7637L4.6352 31.5688L11.9777 30.2922C11.9777 30.2922 13.2482 29.9052 14.4062 31.0092C15.5657 32.1132 17.7737 33.9912 17.7737 33.9912C17.7737 33.9912 17.9252 34.3932 20.3132 34.0467",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8467 45.8608L10.0457 43.0183C10.0457 43.0183 9.35569 41.1688 11.0672 40.5898C12.7787 40.0108 14.2967 39.9268 14.2967 39.9268C14.2967 39.9268 15.9812 39.6238 16.6712 41.6383C17.3612 43.6528 17.8307 44.9233 17.8307 44.9233C17.8307 44.9233 17.9957 45.3643 17.4167 45.5308C16.8377 45.6973 16.4222 45.1168 16.3127 44.6758C16.2017 44.2348 15.6782 42.2188 14.9882 42.0538C14.2982 41.8888 12.0617 42.3853 12.0617 42.3853C12.0617 42.3853 11.1782 42.5233 11.4827 43.5718C11.7857 44.6203 12.2282 46.3318 12.2282 46.4983C12.2282 46.6648 11.3117 47.5093 10.8482 45.8638L10.8467 45.8608Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6309 44.4365L13.4354 44.6989C13.1433 44.763 12.9585 45.0518 13.0226 45.3439L13.0647 45.5358C13.1288 45.828 13.4176 46.0128 13.7097 45.9487L14.9053 45.6862C15.1974 45.6221 15.3822 45.3333 15.3181 45.0412L15.2759 44.8493C15.2118 44.5572 14.923 44.3724 14.6309 44.4365Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9778 41.3337L13.8798 40.9392",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8274 43.6123L22.0264 40.7698C22.0264 40.7698 21.3364 38.9203 23.0479 38.3413C24.7594 37.7623 26.2774 37.6783 26.2774 37.6783C26.2774 37.6783 27.9619 37.3753 28.6519 39.3898C29.3419 41.4043 29.8114 42.6748 29.8114 42.6748C29.8114 42.6748 29.9764 43.1158 29.3974 43.2823C28.8184 43.4488 28.4029 42.8683 28.2934 42.4273C28.1824 41.9863 27.6589 39.9703 26.9689 39.8053C26.2789 39.6403 24.0424 40.1368 24.0424 40.1368C24.0424 40.1368 23.1589 40.2748 23.4634 41.3233C23.7664 42.3718 24.2089 44.0833 24.2089 44.2498C24.2089 44.4163 23.2924 45.2608 22.8289 43.6153L22.8274 43.6123Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6114 42.1901L25.4159 42.4525C25.1238 42.5166 24.9389 42.8054 25.0031 43.0975L25.0452 43.2894C25.1093 43.5815 25.3981 43.7664 25.6902 43.7023L26.8857 43.4398C27.1778 43.3757 27.3627 43.0869 27.2985 42.7948L27.2564 42.6029C27.1923 42.3108 26.9035 42.126 26.6114 42.1901Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9583 39.0852L25.8618 38.6922",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0608 40.9348L34.2598 38.0923C34.2598 38.0923 33.5698 36.2428 35.2813 35.6638C36.9928 35.0848 38.5108 35.0008 38.5108 35.0008C38.5108 35.0008 40.1953 34.6978 40.8853 36.7123C41.5753 38.7268 42.0448 39.9973 42.0448 39.9973C42.0448 39.9973 42.2098 40.4383 41.6308 40.6048C41.0518 40.7698 40.6363 40.1908 40.5268 39.7498C40.4158 39.3088 39.8923 37.2928 39.2023 37.1278C38.5123 36.9628 36.2758 37.4593 36.2758 37.4593C36.2758 37.4593 35.3923 37.5973 35.6968 38.6458C35.9998 39.6943 36.4423 41.4058 36.4423 41.5723C36.4423 41.7388 35.5258 42.5833 35.0623 40.9378L35.0608 40.9348Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8448 39.5126L37.6493 39.775C37.3572 39.8391 37.1723 40.1279 37.2365 40.42L37.2786 40.612C37.3427 40.9041 37.6315 41.0889 37.9236 41.0248L39.1191 40.7623C39.4112 40.6982 39.5961 40.4095 39.5319 40.1173L39.4898 39.9254C39.4257 39.6333 39.1369 39.4485 38.8448 39.5126Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1926 36.4076L38.0946 36.0146",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4338 17.3594L26.6758 19.3889C26.6758 19.3889 31.5613 19.0574 32.5558 19.5959C33.5503 20.1344 41.0968 24.7139 41.0968 24.7139",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8579 24.2308L51.7279 27.3103",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5656 24.2307L44.1096 25.7097",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49341 31.2449L9.90741 34.2524L11.1914 38.4599L14.3384 37.9379L14.9999 35.7854L19.8029 34.8524L21.5009 36.2114L26.6354 35.3294L28.1984 32.8979",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8568 35.8604L32.4328 34.9844L28.7053 35.6189L28.0438 36.6959L20.9218 37.8959L19.2643 36.6959L16.3663 37.1924L15.3313 39.7874",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5872 40.8208L9.49371 41.1358L7.71321 36.0148L6.80271 34.8523L4.60821 35.2468L4.30371 34.7638",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M23.958 23.5452C24.5851 23.5452 25.0935 23.0368 25.0935 22.4097C25.0935 21.7825 24.5851 21.2742 23.958 21.2742C23.3309 21.2742 22.8225 21.7825 22.8225 22.4097C22.8225 23.0368 23.3309 23.5452 23.958 23.5452Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1298 27.6387C24.6625 27.6387 25.0943 27.2069 25.0943 26.6742C25.0943 26.1415 24.6625 25.7097 24.1298 25.7097C23.5971 25.7097 23.1653 26.1415 23.1653 26.6742C23.1653 27.2069 23.5971 27.6387 24.1298 27.6387Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9579 25.7083C25.7796 25.7083 27.2564 24.2315 27.2564 22.4098C27.2564 20.5881 25.7796 19.1113 23.9579 19.1113C22.1362 19.1113 20.6594 20.5881 20.6594 22.4098C20.6594 24.2315 22.1362 25.7083 23.9579 25.7083Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGravityHammer);
export default __webpack_public_path__ + "static/media/Gravity Hammer.1181052fbd143986d2421f3f51003790.svg";
export { ForwardRef as ReactComponent };